// extracted by mini-css-extract-plugin
export default {"title":"UserProfileForm_title__VcIo4"};